/**
 * Cache url of user's avatar to an Image object
 */
const avatarCache = {};

/**
 * Adds an avatar URL to the cache.
 * @param {string} avatarUrl - The user's avatar URL
 * @param {string} image - The Image HTML element.
 */
const addToCache = (avatarUrl, image) => {
	avatarCache[avatarUrl] = image;
};

/**
 * Removes an avatar URL from the cache.
 * @param {string} avatarUrl - The user's avatar URL
 */
const removeFromCache = (avatarUrl) => {
	if (avatarUrl in avatarCache) {
		delete avatarCache[avatarUrl];
	}
};

/**
 * @param {string} avatarUrl - The user's avatar URL
 * @returns {string|null} - The URL of the avatar or null if not found.
 */
function getAvatarFromCache(avatarUrl) {
	return avatarUrl in avatarCache ? avatarCache[avatarUrl] : null;
}

export { avatarCache, addToCache, removeFromCache, getAvatarFromCache };
